// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseSbatLectureRow_root__WjRJb","detail":"CoursePauseSbatLectureRow_detail__MoKT1","selectedLecture":"CoursePauseSbatLectureRow_selectedLecture__OdojK"};